import {
  SET_ACCOUNT_ID,
  SET_PRACTICE_ID,
  SET_USER_PROFILE,
} from "../actions/types";
import initialState from "./initialState";

const practiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRACTICE_ID:
      return {
        ...state,
        practice_id: action.payload,
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload,
      };
    case SET_ACCOUNT_ID:
      return {
        ...state,
        account_id: action.payload,
      };
    default:
      return state;
  }
};

export default practiceReducer;
